// Presentation only: the IRS directory and lookup/search keys retain their original names.
const institutionNameAbbreviations = new Set(["US", "USA", "UK", "UAE", "EU", "FI", "FFI", "LLC", "LLP", "LP", "PLC", "AG", "SA", "SAS", "SARL", "SCA", "SCS", "SE", "BV", "NV", "KG", "KGaA", "GmbH", "PTC", "SPV", "SICAV", "SICAF", "SIF", "RAIF", "UCITS", "ETF", "ETFs", "REIT", "REITs", "ICAV", "ICVC", "OEIC", "PCC", "VCC", "II", "III", "IV", "VI", "VII", "VIII", "IX", "XI", "XII"] .map(word => word.toUpperCase()));
export default function formatInstitutionName(value) {
  return String(value || "").replace(/[\p{L}\p{N}]+(?:[’'][\p{L}\p{N}]+)*/gu, word => {
    const upper = word.toUpperCase();
    if (institutionNameAbbreviations.has(upper)) return upper;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
}

